/**
 * Shared UI label strings.
 *
 * Centralized here so the same text appears consistently wherever it is
 * rendered. Update once to roll out copy changes.
 */

/** Display name for the Customer Admin Portal link target. */
export const CUSTOMER_ADMIN_PORTAL_LABEL = "Customer Admin Portal";
